/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react"

export type ThemeContextType = {
    isDarkTheme: boolean
    toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const useThemeContext = () => {
    const context = useContext(ThemeContext)
    if (!context) {
        throw new Error("useThemeconext must be used within a ThemeProvider")
    }
    return context
}

export const ThemeContextProvider = ({ children }: PropsWithChildren<object>) => {
    const [isDarkTheme, setIsDarkTheme] = useState<boolean>(false)

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme")
        if (savedTheme) {
            setIsDarkTheme(savedTheme === "dark")
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("theme", isDarkTheme ? "dark" : "light")
    }, [isDarkTheme])

    const toggleTheme = () => setIsDarkTheme(!isDarkTheme)

    return (
        <ThemeContext.Provider
            value={{
                isDarkTheme,
                toggleTheme,
            }}
        >
            {children}
        </ThemeContext.Provider>
    )
}
